import {
    QUERY_CHANGE,
    FILTER_CHANGE,
    CLEAR_ALL,
    PAGINATION_CHANGE,
    FILTER_SET,
    FILTER_UPDATE,
    FILTER_CLEAR,
    FILTER_CLEAR_GROUP,
    FILTER_SET_GROUP,
    MULTIPLE_FILTERS_UPDATE
} from '../constants/ActionTypes';
import { getQueryParamName } from '../selectors/AgendaSelectors';
import {FILTERS_NAMES} from 'web-common/scripts/constants/Agenda';

export const queryChangedAction = query => ({type: QUERY_CHANGE, query});

export const filterChangedAction = query => ({type: FILTER_CHANGE, query});

export const paginationChangedAction = query => ({type: PAGINATION_CHANGE, query});

export const clearAllAction = () => ({type: CLEAR_ALL});

export const setFilterAction = data => ({type: FILTER_SET, data});

export const updateFilterAction = data => ({type: FILTER_UPDATE, data});

export const updateMultipleFiltersAction = data => ({type: MULTIPLE_FILTERS_UPDATE, data});

export const clearFilterAction = data => ({type: FILTER_CLEAR, data});

export const clearFilterGroupAction = data => ({type: FILTER_CLEAR_GROUP, data});

export const clearAll = () => dispatch => {
    dispatch(clearAllAction());
};

export const queryChanged = options => dispatch => {
    dispatch(queryChangedAction(options));
};

export const filterChanged = options => dispatch => {
    dispatch(filterChangedAction(options));
};

export const paginationChanged = options => dispatch => {
    dispatch(paginationChangedAction(options));
};

export const setFilter = data => dispatch => {
    dispatch(setFilterAction(data));
};

export const updateFilter = data => dispatch => {
    dispatch(updateFilterAction(data));
};

export const clearFilter = data => dispatch => {
    dispatch(clearFilterAction(data));
};

export const clearFilterGroup = data => dispatch => {
    dispatch(clearFilterGroupAction(data));
};
